import React from 'react';
import { AIBias } from '../../../ai/responseSchema';

export function ThesisSummaryCard({ bias, conviction }: { bias: AIBias; conviction: number }) {
  const c = bias === 'bullish' ? 'var(--green)' : bias === 'bearish' ? 'var(--red)' : bias === 'mixed' ? 'var(--amber)' : 'var(--blue-dim)';
  const icon = bias === 'bullish' ? '▲' : bias === 'bearish' ? '▼' : '⇄';
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{ fontSize: 12, fontWeight: 700, fontFamily: 'var(--mono)', letterSpacing: '.5px',
        color: c, border: `1px solid ${c}44`, background: `${c}12`, padding: '2px 10px', borderRadius: 4 }}>
        {icon} {bias.toUpperCase()}
      </span>
      <span style={{ fontSize: 22, fontWeight: 700, color: c, fontFamily: 'var(--mono)' }}>{conviction}%</span>
    </div>
  );
}
